import { createSlice } from "@reduxjs/toolkit";


const ThemeSclice = createSlice({
    name: "userData",

    initialState: {
        theme: true,
      
    },
    reducers: {
        setTheme: (state, action) => {
            state.theme = action.payload
        },
        getTheme: (state, action) => {
           return state.theme
        }
    },

})
export const { setTheme, getTheme } = ThemeSclice.actions

export default ThemeSclice.reducer;